var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27728 14.0546C6.36272 14.0546 4 11.6918 4 8.77728C4 5.86272 6.36272 3.5 9.27728 3.5C12.1918 3.5 14.5546 5.86272 14.5546 8.77728C14.5546 9.99681 14.1409 11.1197 13.4462 12.0133L17 15.5671L16.0671 16.5L12.5133 12.9462C11.6197 13.6409 10.4968 14.0546 9.27728 14.0546ZM13.2354 8.77728C13.2354 10.9632 11.4634 12.7352 9.27748 12.7352C7.09156 12.7352 5.31952 10.9632 5.31952 8.77728C5.31952 6.59136 7.09156 4.81932 9.27748 4.81932C11.4634 4.81932 13.2354 6.59136 13.2354 8.77728Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5778e6e42a4c238dbcadbb02b6b03174.svg";
export { ForwardRef as ReactComponent };